import { useTranslation } from 'react-i18next';

import useFetchTriggerOptions from 'components/domain/automation/triggers/useFetchTriggerOptions';
import SelectField from 'components/forms/selectField/SelectField';
import { orderBy } from 'utils/arrayUtils';

const TriggerAddEditModalServiceField = () => {
  const { t } = useTranslation();
  const { data: triggerOptions, isLoading } = useFetchTriggerOptions();

  const serviceOptions = (triggerOptions?.option.services ?? []).map(
    (service) => {
      return {
        label: service.name,
        value: service.uid,
      };
    },
  );

  const options = [
    { label: t('pageAutomations.triggers.modal.serviceUidSelect'), value: '' },
    ...orderBy(serviceOptions, [{ field: 'label', order: 'asc' }]),
  ];

  return (
    <SelectField
      colSmInput={12}
      isLoading={isLoading}
      label={t('pageAutomations.triggers.modal.serviceUid')}
      labelOnTop
      name="serviceUid"
      options={options}
      required
    />
  );
};

export default TriggerAddEditModalServiceField;
